import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';

import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import { DialogPerfis } from './DialogPerfis';

import { AuthContext } from '../contexts/AuthContext';
import api from '../api/api';
import { PermissaoLoader } from "./PermissaoLoader";
import { permissions_check } from "../utils/rotas_permissao";
import { FilterContext } from '../contexts/FilterContext';

export const TabelaPerfisDuplicados = () => {
    const toast = useRef(null);
    const [perfisTotal, setPerfisTotal] = useState([]);
    const [perfis, setPerfis] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const [showHistorico, setShowHistorico] = useState(false);
    const [perfil, setPerfil] = useState(null);
    const [showCertificado, setShowCertificado] = useState(false);
    const [perfilConcluido, setPerfilConcluido] = useState("");
    const [showNaoConcluido, setShowNaoConcluido] = useState(false);
    const history = useHistory();
    const [showListaPerfis, setShowListaPerfis] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedDeficiencia, setSelectedDeficiencia] = useState(null);
    const [sortable, setSortable] = useState('DESC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tipos, setTipos] = useState([]);
    const [isShowReset, setIsShowReset] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [userToUpdate, setUserToUpdate] = useState();
    const { filter, setFilter } = useContext(FilterContext);
    const { permissoes, updatePasswordUserPerfil } = useContext(AuthContext);

    const [dePerfilId, setDePerfilId] = useState("");
    const [paraPerfilId, setParaPerfilId] = useState("");

    const handleSubmit = async () => {
        if (!dePerfilId || !paraPerfilId) {
            toast.current.show({
                severity: "warn",
                summary: "Atenção",
                detail: "Preencha ambos os IDs"
            });
            return;
        }

        setLoading(true);

        try {
            const { data } = await api.post(
                `/perfil/ajustarDuplicados/${dePerfilId}/${paraPerfilId}`
            );

            if (data === true) {
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Perfis ajustados com sucesso"
                });

                // 🧹 limpa os campos
                setDePerfilId("");
                setParaPerfilId("");
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Não foi possível ajustar os perfis"
                });
            }
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: error.response?.data?.message || error.message
            });
        } finally {
            await getPerfis();
            setLoading(false);
        }
    };



    const schema = Yup.object().shape({
        senha: Yup
            .string()
            .required("A senha é obrigatória")
    });
    const formik = useFormik({
        initialValues: {
            senha: ''
        },
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: (data) => {
            handleSubmit(data);
        }
    })



    const handleResetClick = (data) => {
        setUserToUpdate({
            email: data.email,
            nome: data.nome,
        });
        setIsShowReset(true);
    }

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Perfis Duplicados</h2>
            </div>
            <div className="p-grid p-col-12 p-m-0 p-p-0">
                <Toast ref={toast} />

                <div className="p-col-12 p-md-3">
                    <label>Perfil a ser substituído (dePerfilId)</label>
                    <InputText
                        value={dePerfilId}
                        onChange={(e) => setDePerfilId(e.target.value)}
                        placeholder="ID do perfil duplicado"
                    />
                </div>

                <div className="p-col-12 p-md-3">
                    <label>Perfil correto (paraPerfilId)</label>
                    <InputText
                        value={paraPerfilId}
                        onChange={(e) => setParaPerfilId(e.target.value)}
                        placeholder="ID do perfil correto"
                    />
                </div>

                <div className="p-col-12 p-md-3 p-my-2">
                    <Button
                        label="Ajustar Perfis"
                        icon="pi pi-check"
                        loading={loading}
                        onClick={handleSubmit}
                    />
                </div>
            </div>

        </div>
    );


    const getPerfis = useCallback(async (event) => {
        setIsLoading(true)
        setPerfis([])

        try {

            console.log("chegou aqui....")

            const respElements = await api.get(`perfil/duplicados`);
            setPerfis(respElements.data);
            setTotalRecords(respElements.data.totalElements);


        }
        catch (error) {

            toast.current.show({ severity: 'error', summary: 'Erro ao obter perfis', detail: error.toString() });
        }

        setIsLoading(false)
    })

    useEffect(() => {
        const fetchPerfis = async () => {
            try {
                await getPerfis();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchPerfis();

    }, [])

    const actionBodyTemplate = (rowData) => {
        const hasEditPermission = permissions_check(
            "perfis",
            "editar",
            permissoes
        );
        return (
            <div className="actions">
                <Button
                    icon="pi pi-key"
                    className="p-button-rounded p-mr-2 p-button-warning"
                    onClick={() => handleResetClick(rowData)}
                    tooltip="Alterar Senha"
                    tooltipOptions={{ position: "top" }}
                />
            </div>
        );
    }

    function desformat(data) {
        return data.replace(/[\D]/g, "");
    }

    function formatCpf(data) {

        const cpf = data != null ? data.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4") : data;

        return cpf;
    }

    const codBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }


    const cpfBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">CPF</span>
                    {rowData.cpf === ""
                        ? <span className="table-data">NÃO INFORMADO</span>
                        : <span className="table-data">{formatCpf(rowData.cpf)}</span>}
                </p>
            </React.Fragment>
        );
    }

    const emailBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Email</span>
                    {rowData.email === ""
                        ? <span className="table-data">NÃO INFORMADO</span>
                        : <span className="table-data">{rowData.email}</span>}
                </p>
            </React.Fragment>
        );
    }

    const celularBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Celular</span>
                    {rowData.celular === ""
                        ? <span className="table-data">NÃO INFORMADO</span>
                        : <span className="table-data">{rowData.celular}</span>}
                </p>
            </React.Fragment>
        );
    }

    const handlePrintClick = () => {
        setShowListaPerfis(true);
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
                <DialogPerfis
                    visible={showListaPerfis}
                    setVisible={setShowListaPerfis}
                    perfil={perfis}
                />

                <div className="p-my-0 p-dir-rev p-col">
                    <div className="p-my-0">
                        <Button
                            textalign="center"
                            icon="pi pi-print"
                            className="p-button-secondary"
                            style={{ width: '35px' }}
                            onClick={handlePrintClick}
                            tooltip="Gerar relatório"
                            tooltipOptions={{ position: 'top' }}
                        />
                    </div>
                </div>


                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">

                        <DataTable style={{ width: '100%' }}
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getPerfis}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={perfis}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma perfil encontrado"
                            loading={isLoading}
                            dataKey="id"

                        >

                            <Column style={{ width: '10%' }}
                                field="id"
                                header="Código"
                                sortable={sortable}
                                body={codBodyTemplate}

                            />

                            <Column style={{ width: '20%' }}
                                field="nome"
                                header="Nome"
                                sortable={sortable}
                                body={nomeBodyTemplate}

                            />

                            <Column style={{ width: '12.5%' }}
                                field="cpf"
                                header="CPF"
                                sortable={sortable}
                                body={cpfBodyTemplate}

                            />


                            <Column style={{ width: '20%' }}
                                field="email"
                                header="Email"
                                sortable={sortable}
                                body={emailBodyTemplate}

                            />


                            <Column style={{ width: '20%' }}
                                field="celular"
                                header="Celular"
                                sortable={sortable}
                                body={celularBodyTemplate}

                            />

                            {/* <Column style={{ width: '13.5%' }}
                                header="Ações"
                                body={actionBodyTemplate}

                            /> */}

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}